import { IconProps } from '@chakra-ui/react';
import { PlatformInstagramBorderIcon } from 'ui-components/dist/PlatformInstagramBorderIcon';
import { PlatformSnapchatColorIcon } from 'ui-components/dist/PlatformSnapchatColorIcon';
import { PlatformTikTokColorIcon } from 'ui-components/dist/PlatformTikTokColorIcon';
import { PlatformYouTubeColorIcon } from 'ui-components/dist/PlatformYouTubeColorIcon';
import {
  ALL_SOCIAL_PLATFORM_TYPE,
  PARTIALLY_SUPPORTED_PLATFORMS,
  SOCIAL_PLATFORMS,
} from '~/constants';

interface Props extends Omit<IconProps, 'css'> {
  platform: ALL_SOCIAL_PLATFORM_TYPE;
  trackId?: string;
}

export const ContentCardPlatformIcon: React.FC<Props> = ({
  platform,
  trackId,
  ...props
}) => {
  const PlatformIconComponent = {
    [SOCIAL_PLATFORMS.instagram]: PlatformInstagramBorderIcon,
    [SOCIAL_PLATFORMS.tiktok]: PlatformTikTokColorIcon,
    [SOCIAL_PLATFORMS.youtube]: PlatformYouTubeColorIcon,
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: PlatformSnapchatColorIcon,
  }[platform];

  return <PlatformIconComponent track-id={trackId} {...props} />;
};
